import { render, staticRenderFns } from "./AdvertisementBanner.vue?vue&type=template&id=60b234e6&scoped=true&"
import script from "./AdvertisementBanner.vue?vue&type=script&lang=js&"
export * from "./AdvertisementBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementBanner.vue?vue&type=style&index=0&id=60b234e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b234e6",
  null
  
)

export default component.exports